export default __webpack_public_path__ + "static/media/mindmap_empathie.8bcc3fa5.png";